
const InvoiceTableBody = ({data}:any) => {
  
  return (
   <>
   {data?.invoiceItems?.length > 0 ? (
        data.invoiceItems.map((item: any, i: number) => (
          <tr key={item.id}>
            <td
              style={{
                width: "12%",
                textAlign: "center",
                borderBottom: "1px solid rgba(82, 82, 108, 0.2)",
                background: "#F5F6F9",
                padding: "16px",
              }}
            >
              <span style={{ opacity: "0.8" }}>{i + 1}</span>
            </td>
            <td
              style={{
                width: "12%",
                borderBottom: "1px solid rgba(82, 82, 108, 0.2)",
                background: "#F5F6F9",
                padding: "16px",
              }}
            >
              <span>{item.item}</span>
            </td>
            <td
              style={{
                width: "12%",
                textAlign: "center",
                borderBottom: "1px solid rgba(82, 82, 108, 0.2)",
                background: "#F5F6F9",
                padding: "16px",
              }}
            >
              <span>{item.quantity}</span>
            </td>
            <td
              style={{
                width: "12%",
                textAlign: "center",
                borderBottom: "1px solid rgba(82, 82, 108, 0.2)",
                padding: "16px",
                background: "#F5F6F9",
              }}
            >
              <span>{item.tax || "N/A"}</span> {/* Fallback for missing tax */}
            </td>
            <td
              style={{
                width: "12%",
                textAlign: "center",
                borderBottom: "1px solid rgba(82, 82, 108, 0.2)",
                background: "#F5F6F9",
                padding: "16px",
              }}
            >
              <span style={{ color:"#6BC6AF", opacity: "0.9" }}>
                ${item.price}.00
              </span>
            </td>
            <td
              style={{
                width: "12%",
                textAlign: "center",
                borderBottom: "1px solid rgba(82, 82, 108, 0.2)",
                background: "#F5F6F9",
                padding: "16px",
              }}
            >
              <span style={{ color: "#6BC6AF", opacity: "0.9" }}>
                ${item.total}.00
              </span>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td
            colSpan={6}
            style={{
              textAlign: "center",
              padding: "16px",
              borderBottom: "1px solid rgba(82, 82, 108, 0.2)",
              background: "#F5F6F9",
            }}
          >
            <span>No items found</span>
          </td>
        </tr>
      )}
    </>
  );
};

export default InvoiceTableBody;
